import {Transport} from "@/services/transport";
// import store from "@/store";
// import store from "@/store";

export default class BaseAPI {

     constructor(endpoint ) {
        this.http = new Transport(endpoint);
    }
    abort(){
         this.http.abort();
    }
    // eslint-disable-next-line no-unused-vars
    create(data){}
    // eslint-disable-next-line no-unused-vars
    read(identifier){}
    // eslint-disable-next-line no-unused-vars
    update(identifier, data){}
    // eslint-disable-next-line no-unused-vars
    delete(identifier){}
}
